if (typeof window !== "undefined") window.__BUILD_TAG__ = "tresopilot-v4.21.33-dashboard-tour";
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Global CTA tracking (first‑party). Keeps working even when cookies/3p scripts are blocked.
import { installCtaTracking } from '@/lib/ctaTracking'

// PERF: avoid bundling Supabase/Meta tracking in the initial public bundle.
// We lazy-load tracking modules only when a CTA is clicked.
async function lazyTrackEvent(payload) {
  try {
    const mod = await import('@/api/trackEvent')
    return await mod.trackEvent(payload)
  } catch {
    return false
  }
}

async function lazySendMetaEvent(payload) {
  try {
    const mod = await import('@/api/metaCapi')
    return await mod.sendMetaEvent(payload)
  } catch {
    return null
  }
}

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

// Install once
installCtaTracking({ trackEvent: lazyTrackEvent, sendMetaEvent: lazySendMetaEvent, enabled: () => true });

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)
